import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import AddExternalCred from "./components/addExternalCred";
import { SearchTypeEnum } from "../../constants/appConstant";
import { respEnum } from "../../constants/appConstant";

const ExternalCred = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!open && refId) {
      setRefId(null);
    }
  }, [open]);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await Common.ApiService.getInstance().request(
        "GetExternalCreds",
        {},
        "GET",
        false
      );

      if (response?.status === respEnum.Success) {
        const creds =
          response.data && response.data.length > 0 ? response.data : [];
        // Convert single record or array to array format for table
        setData(Array.isArray(creds) ? creds : [creds].filter(Boolean));
      }
    } catch (error) {
      console.error("Error fetching credentials:", error);
    } finally {
      setLoading(false);
    }
  };

  // const _handleDelete = async (id) => {
  //   const isConfirmed = await Common.SweetAlert.confirmation(
  //     "Are you sure you want to delete this External Credential?",
  //     "Delete External Credential"
  //   );
  //   if (isConfirmed) {
  //     try {
  //       // Note: Delete endpoint might need to be added to backend
  //       let resp = await Common.ApiService.getInstance().request(
  //         `DeleteExternalCred?id=${id}`,
  //         {},
  //         "Delete"
  //       );
  //       Common.SweetAlert.alert(
  //         resp.message || "Deleted successfully",
  //         "success"
  //       );
  //       setTimeout(() => {
  //         getData();
  //       }, 500);
  //     } catch (error) {
  //       Common.SweetAlert.alert("Delete endpoint not implemented yet", "error");
  //     }
  //   }
  // };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    // {
    //   type: "delete",
    //   onClick: (val) => _handleDelete(val.id),
    // },
  ];

  const _thead = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    { title: "Base URL", type: "text", isVisible: true, key: "baseurl" },
    { title: "Username", type: "text", isVisible: true, key: "username" },
    { title: "Password", type: "text", isVisible: true, key: "password" },
    {
      title: "X-CSRF Token",
      type: "text",
      isVisible: true,
      key: "x_csrf_token",
    },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <AdvanceTable
        title={"External Credentials"}
        columns={_thead.filter((item) => item.isVisible)}
        data={{ data: data }}
        getData={getData}
        addButton={() => (
          <AddExternalCred
            id={refId}
            onClose={() => getData()}
            open={open}
            setOpen={setOpen}
          />
        )}
        showPagination={false}
        showAddButton
        actionButtons={actions}
        updateTrigger={_addUpdateTrigger}
        search={SearchTypeEnum.Local_Search}
        searchInputClassName="custom-search-mobile"
      />
    </>
  );
};

export default ExternalCred;
